import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { FeedbackResponse } from '../api-types/director';
import { OperationType } from '../components/cookbook/Feedback/telemetry';

type FeedbackToast = {
  id: string;
  title: string;
  operationType: OperationType;
  onDismiss?: () => void;
  onSuccess?: (params: FeedbackResponse) => void;
  warehouseId: string;
};

type FeedbackToastMetadata = {
  id: string;
  closed: boolean;
  expirationTime: string;
};

export const feedbackToastStateAtom = atom<FeedbackToast | null>(null);

const FEEDBACK_TOASTS_METADATA_KEY = 'feedbackToastsMetadata';

let feedbackMetadata;

try {
  const metadata = localStorage.getItem(FEEDBACK_TOASTS_METADATA_KEY);

  feedbackMetadata = metadata ? JSON.parse(metadata) : [];
} catch {
  feedbackMetadata = [];
}

export const feedbackToastsMetadataStateAtom = atomWithStorage<FeedbackToastMetadata[]>(
  FEEDBACK_TOASTS_METADATA_KEY,
  feedbackMetadata,
);
